module.exports = __webpack_public_path__ + "static/media/Inter-MediumItalic.1895fa29.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-MediumItalic.woff2
// module id = 700
// module chunks = 21